import React from 'react';
//import Layout from './componentes/Layout/Layout.tsx';
import AuthState from './context/auth/authState.js';
import 'react-day-picker/lib/style.css';
import './skeleton_styles.css';
import './styles/styles.css';
import '@movivendor/mv-components/styles.css';
import { AppRouter } from './routes/AppRouter';

function App() {

  const loginData = {
    data: {
      token: "",
      status: false,
      usuario: ""
    }
  }

  return (
    <AuthState loginData={{
      token: loginData.data.token,
      autenticado: loginData.data.status,
      usuario: loginData.data.usuario
    }}>
      {/* <Layout token={loginData.data.token}/> */}
      <AppRouter token={loginData.data.token} />
    </AuthState>

  );
}

export default App;
